import { useEffect } from 'react';
import { Control, useFieldArray } from 'react-hook-form';
import { FormFields } from '../IGPRScore.interface';

export default function useInputGeneratorFields(
  control: Control<FormFields>,
  fieldArrayName: 'problems' | 'medications'
) {
  const { fields, append } = useFieldArray({
    control,
    name: fieldArrayName
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({ value: '' });
    }
  }, [append, fields]);

  return { fields, append };
}
